import t from "@ext/localization/locale/translate";
import {
	type MultiSelectProps,
	type SearchSelectOption,
	SearchSelectTag,
	MultiSelect as UiKitMultiSelect,
} from "ics-ui-kit/components/search-select";

export const MultiSelect = <T extends SearchSelectOption = SearchSelectOption>(props: MultiSelectProps<T>) => {
	const { disabled, onClear, onLabelClick, renderOption } = props;

	// ics-ui-kit keeps the clear button and the tag close buttons on a disabled MultiSelect
	const renderDisabledOption: MultiSelectProps<T>["renderOption"] = (data) => {
		const custom = renderOption?.(data);
		if (custom !== undefined || data.type !== "trigger") return custom;
		return (
			<SearchSelectTag
				key={data.option.value}
				onClose={() => {}}
				onLabelClick={() => onLabelClick?.(data.option)}
				readonly
			>
				{data.option.label}
			</SearchSelectTag>
		);
	};

	return (
		<UiKitMultiSelect
			emptyText={t("multiSelect.empty")}
			errorText={t("multiSelect.error")}
			inputHintText={t("multiSelect.inputHint")}
			loadingText={t("multiSelect.loading")}
			placeholder={t("multiSelect.placeholder")}
			searchPlaceholder={t("multiSelect.search")}
			{...props}
			onClear={disabled ? undefined : onClear}
			renderOption={disabled ? renderDisabledOption : renderOption}
		/>
	);
};
